
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';
import ContactModal from '../../../components/feature/ContactModal';

export default function AboutCTASection() {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <>
      <section 
        className="py-20 relative overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.9), rgba(147, 51, 234, 0.9)), url('/resources/about-cta-001.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white relative z-10">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-5xl font-bold mb-6">
              {t('ready_to_start')}
            </h2>
            <p className="text-lg md:text-xl mb-2 text-blue-100">
              {t('ready_to_start_en')}
            </p>
            <p className="text-xl md:text-2xl mb-12 text-blue-100 max-w-3xl mx-auto leading-relaxed">
              {t('ready_to_start_desc')}
            </p>
            
            <div className="flex justify-center">
              <Button 
                size="lg"
                onClick={() => setIsContactModalOpen(true)}
                className="text-lg px-10 py-4 bg-white text-blue-600 hover:bg-gray-100"
              >
                <i className="ri-customer-service-line mr-2"></i>
                {t('contact_us')}
              </Button>
            </div>

            <div className="mt-16 grid md:grid-cols-3 gap-8 text-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <i className="ri-mail-line text-3xl mb-4"></i>
                <h3 className="text-lg font-semibold mb-2">{t('email_consultation')}</h3>
                <p className="text-blue-100">business@koluno.com</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <i className="ri-telegram-fill text-3xl mb-4"></i>
                <h3 className="text-lg font-semibold mb-2">{t('contact_telegram')}</h3>
                <p className="text-blue-100">@koluno2020</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <i className="ri-wechat-line text-3xl mb-4"></i>
                <h3 className="text-lg font-semibold mb-2">{t('wechat_consultation')}</h3>
                <p className="text-blue-100">ljy520155</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </>
  );
}
